<div [ngClass]="!mode ? 'example-wrapper' : 'outer-example-wrapper'">
  <div class="checkout-upsell-container" [ngStyle]="mainBackgroundStyle">
    @if (isInlineMode) {
      <div class="inline-goals-section" [ngStyle]="sequentialSectionStyle">
        @if (previousGoalPills.length) {
          <div class="sequential-pills-row">
            @for (pill of previousGoalPills; track pill.label) {
              <span class="sequential-pill">{{ pill.label }} <i class="icon-blue_v"></i></span>
            }
          </div>
        }

        <div class="header-text-row inline-header-text-row">
          <div
            class="header-text-wrapper"
            [ngStyle]="sequentialTextStyle"
            [innerHTML]="getGoalMessageWithCountdown(previewDisplayText) | safe: 'html'"></div>
          @if (
            shouldShowTimer() &&
            template.timerConfiguration.placement === TIMER_PLACEMENTS.BADGE &&
            !isTimerMessageEmpty()
          ) {
            <span class="timer-badge" [ngClass]="getTimerBadgeClass()">
              <span class="timer-icon"></span>
              <span [innerHTML]="getTimerBadgeText() | safe: 'html'"></span>
            </span>
          }
        </div>

        @if (inlineBarGoals.length && template.settings?.thresholdType !== upsellThresholdType.NoThreshold) {
          <div class="inline-bars-container">
            @for (goal of inlineBarGoals; track goal.originalIndex) {
              <div class="inline-bar-column">
                <div class="inline-bar-track">
                  <div
                    class="inline-bar-fill"
                    [ngStyle]="{ 'width.%': goal.fillPercent, 'background-color': singleBarProgressColor }"></div>
                </div>
                @if (goal.showInfo) {
                  <div class="inline-bar-info" [ngStyle]="progressBarLabelSizeStyle">
                    @if (goal.iconUrl) {
                      <img [src]="goal.iconUrl" class="inline-bar-icon" />
                    }
                    @if (goal.progressBarLabel) {
                      <span class="inline-bar-label">{{ goal.progressBarLabel }}</span>
                    }
                  </div>
                }
              </div>
            }
          </div>
        }

        @if (
          shouldShowTimer() &&
          template.timerConfiguration.placement === TIMER_PLACEMENTS.INLINE_BAR &&
          !isTimerMessageEmpty()
        ) {
          <div class="timer-bar" [ngClass]="[getTimerBarClass(), 'timer-bar-align-' + getTimerBarAlignment()]">
            <pdq-icon [icon]="getTimerBarBannerIcon()"></pdq-icon>
            <span [innerHTML]="getTimerBarText() | safe: 'html'"></span>
          </div>
        }
      </div>
    } @else if (isSequentialMode) {
      <div class="sequential-goal-section" [ngStyle]="sequentialSectionStyle">
        @if (previousGoalPills.length) {
          <div class="sequential-pills-row">
            @for (pill of previousGoalPills; track pill.label) {
              <span class="sequential-pill">{{ pill.label }} <i class="icon-blue_v"></i></span>
            }
          </div>
        }
        <div class="sequential-content">
          @if (previewedGoalIconUrl && shouldShowIconInSequential) {
            <img class="sequential-icon" [src]="previewedGoalIconUrl" alt="Goal icon" />
          }
          <div class="sequential-text-wrapper" [ngStyle]="sequentialTextStyle">
            <div class="header-text-row">
              <div
                class="header-text-wrapper"
                [innerHTML]="getGoalMessageWithCountdown(previewDisplayText) | safe: 'html'"></div>
              @if (
                shouldShowTimer() &&
                template.timerConfiguration.placement === TIMER_PLACEMENTS.BADGE &&
                !isTimerMessageEmpty()
              ) {
                <span class="timer-badge" [ngClass]="getTimerBadgeClass()">
                  <span class="timer-icon"></span>
                  <span [innerHTML]="getTimerBadgeText() | safe: 'html'"></span>
                </span>
              }
            </div>
          </div>
        </div>
        @if (
          template.settings?.thresholdType !== upsellThresholdType.NoThreshold && (previewMode === 'threshold' || !mode)
        ) {
          <div class="sequential-progress-bar">
            <div class="progress" [ngStyle]="{ 'background-color': sequentialProgressBarColor }"></div>
          </div>
        }
        @if (
          shouldShowTimer() &&
          template.timerConfiguration.placement === TIMER_PLACEMENTS.INLINE_BAR &&
          !isTimerMessageEmpty()
        ) {
          <div class="timer-bar" [ngClass]="[getTimerBarClass(), 'timer-bar-align-' + getTimerBarAlignment()]">
            <pdq-icon [icon]="getTimerBarBannerIcon()"></pdq-icon>
            <span [innerHTML]="getTimerBarText() | safe: 'html'"></span>
          </div>
        }
      </div>
    } @else {
      <div class="single-bar-section" [ngStyle]="sequentialSectionStyle">
        @if (previousGoalPills.length) {
          <div class="sequential-pills-row">
            @for (pill of previousGoalPills; track pill.label) {
              <span class="sequential-pill">{{ pill.label }} <i class="icon-blue_v"></i></span>
            }
          </div>
        }

        <div class="header-text-row">
          <div
            class="header-text-wrapper"
            [ngStyle]="sequentialTextStyle"
            [innerHTML]="getGoalMessageWithCountdown(previewDisplayText) | safe: 'html'"></div>
          @if (
            shouldShowTimer() &&
            template.timerConfiguration.placement === TIMER_PLACEMENTS.BADGE &&
            !isTimerMessageEmpty()
          ) {
            <span class="timer-badge" [ngClass]="getTimerBadgeClass()">
              <span class="timer-icon"></span>
              <span [innerHTML]="getTimerBadgeText() | safe: 'html'"></span>
            </span>
          }
        </div>

        @if (singleBarCheckpoints.length && template.settings?.thresholdType !== upsellThresholdType.NoThreshold) {
          <div class="single-bar-progress-area">
            <div class="single-bar-labels-row">
              <div class="phantom-spacer"></div>
              @for (cp of singleBarCheckpoints; track cp.originalIndex) {
                <div class="single-bar-label-slot">
                  @if (cp.showInfo && cp.thresholdLabel) {
                    <span class="checkpoint-value" [ngStyle]="progressBarLabelSizeStyle">{{ cp.thresholdLabel }}</span>
                  }
                </div>
              }
            </div>

            <div class="single-bar-track-row">
              <div class="single-bar-track"></div>
              <div
                class="single-bar-fill"
                [ngStyle]="{ 'width.%': singleBarFillPercentage, 'background-color': singleBarProgressColor }"></div>
              <div class="single-bar-circles">
                <div class="phantom-spacer"></div>
                @for (cp of singleBarCheckpoints; track cp.originalIndex; let idx = $index) {
                  <div class="checkpoint-slot">
                    @if (cp.iconUrl) {
                      <img [src]="cp.iconUrl" class="checkpoint-icon" />
                    } @else {
                      <span class="checkpoint-fallback-circle"></span>
                    }
                  </div>
                }
              </div>
            </div>

            <div class="single-bar-labels-row">
              <div class="phantom-spacer"></div>
              @for (cp of singleBarCheckpoints; track cp.originalIndex) {
                <div class="single-bar-label-slot">
                  @if (cp.showInfo && cp.progressBarLabel) {
                    <span class="checkpoint-label" [ngStyle]="progressBarLabelSizeStyle">{{
                      cp.progressBarLabel
                    }}</span>
                  }
                </div>
              }
            </div>
          </div>
        }

        @if (
          shouldShowTimer() &&
          template.timerConfiguration.placement === TIMER_PLACEMENTS.INLINE_BAR &&
          !isTimerMessageEmpty()
        ) {
          <div class="timer-bar" [ngClass]="[getTimerBarClass(), 'timer-bar-align-' + getTimerBarAlignment()]">
            <pdq-icon [icon]="getTimerBarBannerIcon()"></pdq-icon>
            <span [innerHTML]="getTimerBarText() | safe: 'html'"></span>
          </div>
        }
      </div>
    }

    @if (effectiveDisplayType !== 'hide-products') {
      @if (effectiveDisplayType === 'compact') {
        <pdq-card color="white">
          <div class="product-compact" [class.product-compact--mobile]="isMobile" [ngStyle]="cardBackgroundStyle">
            <div class="product-compact__top">
              <div
                class="product-compact__image image-slot"
                [class.image-slot--original]="isOriginalImageFit"
                [ngStyle]="imageBackgroundStyle">
                <img src="assets/icons/checkout_content_default.png" />
                @if (showDiscountBadge) {
                  <span class="discount-badge" [ngStyle]="discountBadgeStyle">{{ discountBadgeText }}</span>
                }
              </div>
              <div class="product-compact__details">
                @if (showsReviewsAt(ReviewsPosition.TOP)) {
                  <pdq-star-rating
                    [rating]="previewReviewRatingOrZero"
                    [reviewCount]="previewReviewCountOrNull"
                    [color]="reviewsConfig?.starColor"
                    [compact]="isMobile"></pdq-star-rating>
                }
                <p class="product-compact__name">
                  <b>Product name</b>
                  @if (showDiscountLabel) {
                    <b class="discount-label" [attr.data-tone]="discountLabelTone">{{ discountLabelText }}</b>
                  } @else if (template?.applyDiscountToRecommendedProducts) {
                    <b>{{ discountLabelText }}</b>
                  }
                </p>
                @if (showsReviewsAt(ReviewsPosition.MIDDLE)) {
                  <pdq-star-rating
                    [rating]="previewReviewRatingOrZero"
                    [reviewCount]="previewReviewCountOrNull"
                    [color]="reviewsConfig?.starColor"
                    [compact]="isMobile"></pdq-star-rating>
                }
                <p class="product-compact__price">
                  @if (template?.settings?.prioritizeRecommendedItemsBy === 'selling-plan') {
                    <span [innerHTML]="safeHtmlTextPrice() | safe: 'html'"></span>
                  } @else {
                    <span class="product-compact__current-price">$9.99</span>
                  }
                  @if (
                    template.settings?.showCompareAtPrice &&
                    template?.settings?.prioritizeRecommendedItemsBy !== 'selling-plan'
                  ) {
                    <span class="product__compare-at-price">$5.99</span>
                  }
                </p>
                @if (showsReviewsAt(ReviewsPosition.BOTTOM)) {
                  <pdq-star-rating
                    [rating]="previewReviewRatingOrZero"
                    [reviewCount]="previewReviewCountOrNull"
                    [color]="reviewsConfig?.starColor"
                    [compact]="isMobile"></pdq-star-rating>
                }
              </div>
              <div class="product-compact__navigation">
                <button class="product-compact__nav-btn" disabled>
                  <pdq-icon icon="side_left_arrow" size="small"></pdq-icon>
                </button>
                <button class="product-compact__nav-btn">
                  <pdq-icon icon="side_right_arrow" size="small"></pdq-icon>
                </button>
              </div>
            </div>
            <div class="product-compact__actions">
              @if (showVariantDropdown) {
                <div class="variant-selector">
                  <span>Select an option</span>
                  <pdq-icon icon="chevron_down" size="smaller"></pdq-icon>
                </div>
              }
              <button class="compact" [ngClass]="{ compact__mobile: isMobile }">{{ ctaButtonText }}</button>
            </div>
          </div>
        </pdq-card>
      } @else if (effectiveDisplayType === 'row') {
        <div class="product-rows-container">
          @for (rowIndex of upsellRowIndices; track rowIndex) {
            <pdq-card color="white">
              <div class="product-row" [ngClass]="[template?.style?.displayType || '']" [ngStyle]="cardBackgroundStyle">
                <div class="product-row__left">
                  <div
                    class="product-row__image image-slot"
                    [class.image-slot--original]="isOriginalImageFit"
                    [ngStyle]="imageBackgroundStyle">
                    <img src="assets/icons/checkout_content_default.png" />
                    @if (showDiscountBadge) {
                      <span class="discount-badge" [ngStyle]="discountBadgeStyle">{{ discountBadgeText }}</span>
                    }
                  </div>
                  <div class="product-row__details">
                    @if (showsReviewsAt(ReviewsPosition.TOP)) {
                      <pdq-star-rating
                        [rating]="previewReviewRatingOrZero"
                        [reviewCount]="previewReviewCountOrNull"
                        [color]="reviewsConfig?.starColor"
                        [compact]="isMobile"></pdq-star-rating>
                    }
                    <p>
                      <b>Product name</b>
                      @if (showDiscountLabel) {
                        <b class="discount-label" [attr.data-tone]="discountLabelTone">{{ discountLabelText }}</b>
                      } @else if (template?.applyDiscountToRecommendedProducts) {
                        <b>{{ discountLabelText }}</b>
                      }
                    </p>
                    @if (showsReviewsAt(ReviewsPosition.MIDDLE)) {
                      <pdq-star-rating
                        [rating]="previewReviewRatingOrZero"
                        [reviewCount]="previewReviewCountOrNull"
                        [color]="reviewsConfig?.starColor"
                        [compact]="isMobile"></pdq-star-rating>
                    }
                    <p style="display: flex; gap: 4px">
                      @if (template?.settings?.prioritizeRecommendedItemsBy === 'selling-plan') {
                        <div [innerHTML]="safeHtmlTextPrice() | safe: 'html'"></div>
                      } @else {
                        <b>$9.99 </b>
                      }
                      @if (
                        template.settings?.showCompareAtPrice &&
                        template?.settings?.prioritizeRecommendedItemsBy !== 'selling-plan'
                      ) {
                        <span class="product__compare-at-price">$11.99</span>
                      }
                    </p>
                    @if (showsReviewsAt(ReviewsPosition.BOTTOM)) {
                      <pdq-star-rating
                        [rating]="previewReviewRatingOrZero"
                        [reviewCount]="previewReviewCountOrNull"
                        [color]="reviewsConfig?.starColor"
                        [compact]="isMobile"></pdq-star-rating>
                    }

                    @for (
                      additionalDisplayText of template.settings.additionalDisplayTexts;
                      track additionalDisplayText;
                      let i = $index
                    ) {
                      <p>
                        {{
                          additionalDisplayText.display === true
                            ? additionalDisplayText.text
                                .replace('{product-type}', 'Flower')
                                .replace('{vendor}', 'Armani')
                            : ''
                        }}
                      </p>
                    }
                  </div>
                </div>
                <div class="product-row__actions">
                  @if (showVariantDropdown) {
                    <div class="variant-selector">
                      <span>Select an option</span>
                      <pdq-icon icon="chevron_down" size="smaller"></pdq-icon>
                    </div>
                  }
                  <button class="row" [ngClass]="{ row__mobile: isMobile }">
                    {{ ctaButtonText }}
                  </button>
                </div>
              </div>
            </pdq-card>
          }
        </div>
      } @else {
        <div
          class="products"
          [class.products--scroll]="isScrollNavigation"
          [class.products--scroll-mobile]="isScrollNavigation && isMobile">
          @for (num of upsellCardIndices; track num) {
            <pdq-card color="white">
              <div
                class="product"
                [ngClass]="[template?.style?.displayType || '']"
                [class.product--mobile]="isMobile"
                [ngStyle]="cardBackgroundStyle">
                <div
                  class="product__image image-slot"
                  [class.image-slot--original]="isOriginalImageFit"
                  [ngStyle]="imageBackgroundStyle">
                  <img src="assets/icons/checkout_content_default.png" />
                  @if (showDiscountBadge) {
                    <span class="discount-badge" [ngStyle]="discountBadgeStyle">{{ discountBadgeText }}</span>
                  }
                </div>
                <div class="product__details">
                  @if (showsReviewsAt(ReviewsPosition.TOP)) {
                    <pdq-star-rating
                      [rating]="previewReviewRatingOrZero"
                      [reviewCount]="previewReviewCountOrNull"
                      [color]="reviewsConfig?.starColor"
                      [compact]="isMobile"></pdq-star-rating>
                  }
                  <p>
                    <b>Product name</b>
                    @if (showDiscountLabel) {
                      <b class="discount-label" [attr.data-tone]="discountLabelTone">{{ discountLabelText }}</b>
                    } @else if (template?.applyDiscountToRecommendedProducts) {
                      <b>{{ discountLabelText }}</b>
                    }
                  </p>
                  @if (showsReviewsAt(ReviewsPosition.MIDDLE)) {
                    <pdq-star-rating
                      [rating]="previewReviewRatingOrZero"
                      [reviewCount]="previewReviewCountOrNull"
                      [color]="reviewsConfig?.starColor"
                      [compact]="isMobile"></pdq-star-rating>
                  }
                  <div class="product-container">
                    @if (template?.settings?.prioritizeRecommendedItemsBy === 'selling-plan') {
                      <div [innerHTML]="safeHtmlTextPrice() | safe: 'html'"></div>
                    } @else {
                      <p>
                        <b>$9.99</b>
                        @if (num === 1 && template.settings?.showCompareAtPrice) {
                          <span class="product__compare-at-price">$11.99</span>
                        }
                      </p>
                    }
                  </div>
                  @if (showsReviewsAt(ReviewsPosition.BOTTOM)) {
                    <pdq-star-rating
                      [rating]="previewReviewRatingOrZero"
                      [reviewCount]="previewReviewCountOrNull"
                      [color]="reviewsConfig?.starColor"
                      [compact]="isMobile"></pdq-star-rating>
                  }
                </div>
                <div class="product__additional-texts">
                  @for (additionalDisplayText of template.settings.additionalDisplayTexts; track $index) {
                    <p>
                      {{
                        additionalDisplayText.display === true
                          ? additionalDisplayText.text.replace('{product-type}', 'Flower').replace('{vendor}', 'Armani')
                          : ''
                      }}
                    </p>
                  }
                </div>
                @if (showVariantDropdown) {
                  <div class="variant-selector">
                    <span>Select an option</span>
                    <pdq-icon icon="chevron_down" size="smaller"></pdq-icon>
                  </div>
                }
                <button class="card">{{ ctaButtonText }}</button>
              </div>
            </pdq-card>
          }
        </div>
      }
      <!-- compact carries its own arrows inside the card, matching NavigationButtons skipping the compact display type -->
      @if (!isScrollNavigation && effectiveDisplayType !== 'compact') {
        <div class="navigation-arrows">
          <pdq-button icon="side_left_arrow" size="large" disabled="true" variant="tertiary"></pdq-button>
          <pdq-button icon="side_right_arrow" size="large" disabled="true" variant="tertiary"></pdq-button>
        </div>
      }
    }
  </div>
</div>
